import type { Translations } from "../keys.js";

export const zhHant = {
  eyebrow: "IBKR Activity Statement",
  title: "盈虧比報表分析",
  uploadMark: "Flex XML",
  uploadTitle: "拖入或選擇 IBKR XML",
  uploadBody: "名稱、帳戶、地址會在畫面與本地分析中脫敏。",
  nfaDisclaimer: "僅供學習與交易復盤，不構成投資建議。",
  chooseFile: "選擇文件",
  account: "帳戶",
  name: "名稱",
  neutralName: "momo",
  period: "期間",
  baseCurrency: "基礎貨幣",
  closed: "平倉",
  executions: "成交",
  netRealized: "淨已實現",
  profitFactor: "Profit Factor",
  winRate: "勝率",
  payoffRatio: "盈虧比",
  expectancy: "期望值",
  executionRecords: "成交記錄",
  canceledOrders: "取消委託",
  medianHoldingDays: "持倉中位數",
  commissionDrag: "佣金拖累",
  closedTradeSum: "逐筆平倉合計",
  grossProfitLoss: "總盈利 / 總虧損",
  averageWinLoss: "平均盈利 / 平均虧損",
  perClosedTrade: "每筆平倉平均",
  flexTradeRecords: "Flex XML 的 Trade 記錄",
  flexCanceledRecords: "Flex XML 的 Order 取消記錄",
  noCanceledRecords: "此 XML 未提供取消委託",
  holdingReview: "Holding",
  holdingReviewTitle: "交易持倉與盈虧比分析",
  holdingReviewHint: "按開平倉匹配後比較不同持倉週期的 PF、盈虧比與勝率。",
  holdingPeriod: "持倉週期",
  holdingIntraday: "日內",
  holdingSwing: "1-7 天",
  holdingPosition: "8-30 天",
  holdingLongTerm: "30 天以上",
  directionReview: "Direction",
  directionReviewTitle: "多空倉位分析",
  directionReviewHint: "按策略曝險拆分多頭、空頭與中性，檢查哪一側更有優勢。",
  longPosition: "多頭",
  shortPosition: "空頭",
  neutralPosition: "中性",
  equityCurve: "Equity Curve",
  dailyRealized: "每日已實現損益",
  payoff: "Payoff",
  winLossDistribution: "贏虧分布",
  periodPerformance: "Period",
  periodHint: "綠柱為盈利，紅柱為虧損；PF 與盈虧比請看下方表格。",
  weekly: "週度",
  monthly: "月度",
  periodColumn: "週期",
  monthColumn: "月份",
  realized: "已實現",
  pf: "PF",
  payoffShort: "盈虧比",
  trades: "筆數",
  assetBreakdown: "Assets",
  assetBreakdownTitle: "股票 / 期權統計",
  asset: "資產",
  medianPnl: "盈虧中位數",
  average: "平均",
  optionReview: "Options",
  optionReviewTitle: "期權標的復盤",
  underlying: "標的",
  date: "日期",
  dateCount: "日期數",
  daysShort: "天",
  hoursShort: "小時",
  minutesShort: "分",
  weakestSession: "最弱交易時段",
  intradaySessionNoData: "無常規盤平倉樣本",
  intradaySessionTitle: "早午尾盤勝率分析",
  intradaySessionHint: "按平倉時間比較早盤、午盤、尾盤的已實現、中位數、平均每筆、PF、盈虧比與勝率。",
  weekdayReviewTitle: "星期幾交易表現",
  weekdayReviewHint: "統計常規盤平倉與自動到期，按星期比較哪天盈虧比最好、哪天最差。",
  weekday: "星期",
  weekdaySunday: "星期日",
  weekdayMonday: "星期一",
  weekdayTuesday: "星期二",
  weekdayWednesday: "星期三",
  weekdayThursday: "星期四",
  weekdayFriday: "星期五",
  weekdaySaturday: "星期六",
  bestDay: "最好",
  worstDay: "最差",
  session: "時段",
  sessionMorning: "早盤",
  sessionMidday: "午盤",
  sessionLate: "尾盤",
  autoExpiry: "自動到期",
  optionLifecycle: "到期／結算",
  optionLifecycleRegularClose: "一般平倉",
  optionLifecycleEp: "到期失效",
  optionLifecycleEx: "行權",
  optionLifecycleA: "被指派",
  optionLifecycleCD: "現金結算",
  optionLifecycleAEx: "自動行權",
  optionLifecycleMEx: "手動行權",
  optionLifecycleGEA: "抵銷到期／指派",
  discipline: "Discipline",
  disciplineRisk: "紀律風險",
  largeLossAlert: "大額虧損警示",
  largeLossDiscipline: "先停手，先守紀律",
  largeLossRule: "這一天的總虧損已超過本期風控門檻。復盤前不要加碼追回，先確認原定止損、最大日虧與停手機制。",
  worstLossDay: "最大單日虧損",
  symbols: "Symbols",
  symbolPerformance: "標的排行榜",
  page: "頁",
  previousPage: "上一頁",
  nextPage: "下一頁",
  offlineCoach: "Offline Coach",
  offlineAdvice: "離線建議",
  bestLoserWins: "Best Loser Wins",
  theme: "主題",
  language: "語言",
  dark: "深色",
  light: "淺色",
  stock: "股票",
  option: "期權",
  other: "其他",
  cash: "現金",
  future: "期貨",
  unknown: "未知",
  winBucketSmall: "小贏",
  winBucketMedium: "中贏",
  winBucketLarge: "大贏",
  lossBucketSmall: "小虧",
  lossBucketMedium: "中虧",
  lossBucketLarge: "大虧",
  chartEmpty: "沒有可繪製的平倉資料",
  dailyChartLegend: "柱狀：每日，線條：累計",
  periodChartLegend: "PF 點：參考 1.00，上限",
  importFailed: "匯入失敗",
  profitStatus: "盈利",
  lossStatus: "虧損",
  flatStatus: "持平",
  costStatus: "成本",
  toggleDetails: "展開明細",
  "error.invalid_flex_xml": "請上傳 IBKR Flex XML 文件。",
  "advice.profit_factor_below_one.title": "PF 低於 1，先處理虧損尾巴",
  "advice.profit_factor_below_one.body": "目前 PF {profitFactor}，代表總盈利還蓋不住總虧損。下一步優先降低單筆大虧、到期歸零與失控加倉，而不是增加交易次數。",
  "advice.profit_factor_thin_edge.title": "PF 有基礎，但容錯很薄",
  "advice.profit_factor_thin_edge.body": "目前 PF {profitFactor}。這種狀態不是不能交易，而是不能讓一兩筆失控虧損吃掉整段成果。先定義單日最大虧損、最晚離場時間與停手機制。",
  "advice.profit_factor_healthy.title": "PF 結構相對健康",
  "advice.profit_factor_healthy.body": "目前 PF {profitFactor}。接下來不要盲目放大頻率，應該找出哪些標的、時段與策略最穩，保留可重複的高品質交易。",
  "advice.winrate_and_payoff_weak.title": "勝率與盈虧比不能同時偏弱",
  "advice.winrate_and_payoff_weak.body": "勝率 {winRate}、盈虧比 {payoffRatio}。這代表你既沒有足夠命中率，也沒有足夠單筆收益補償錯誤。進場前要更嚴格確認目標空間與止損距離。",
  "advice.high_winrate_weak_payoff.title": "勝率在補洞，但平均虧損仍偏重",
  "advice.high_winrate_weak_payoff.body": "勝率 {winRate} 還能支撐部分結果，但盈虧比 {payoffRatio} 代表一筆壞交易會吃掉多筆好交易。這通常不是看不準，而是離場與風險定義太鬆。",
  "advice.overtrade_loss_days.title": "虧損日有加速跡象",
  "advice.overtrade_loss_days.body": "{days} 天同時出現高交易數與負損益。這類日子要單獨復盤第二筆以後的交易：它們是原計畫，還是想把虧損追回來？",
  "advice.auto_expiry_losses.title": "自動到期不是雜訊",
  "advice.auto_expiry_losses.body": "{count} 筆自動到期虧損已納入。到期歸零應該被視為可管理風險，而不是收盤前才處理的意外。建議寫死「最晚離場時間」。",
  "advice.good_loser_base.title": "好的輸家會保護下一筆交易",
  "advice.good_loser_base.body": "本期平均盈利 {avgWin}、平均虧損 {avgLoss}。虧損若在計畫內，是交易成本；虧損若超出計畫，就是風險定義需要收窄。",
  "advice.detach_outcome_from_ego.title": "把輸贏從自尊裡拿出來",
  "advice.detach_outcome_from_ego.body": "復盤時先問：這筆虧損是不是按計畫發生？如果答案是肯定的，它只是成本；如果是否定的，它才是紀律問題。",
  "advice.large_tail_losses.title": "先讓最大虧損變小",
  "advice.large_tail_losses.body": "{count} 筆虧損超過 {threshold}。改善 PF 最快的方式，通常不是提高勝率，而是砍掉會摧毀整週成果的尾部虧損。",
  "advice.asset_group_relative_edge.title": "{stronger} 目前相對更有優勢",
  "advice.asset_group_relative_edge.body": "期權 PF {optionProfitFactor}、股票 PF {stockProfitFactor}。先把資金與注意力放在 PF 更穩的類別，再檢查另一類是否只是偶發試單或情緒交易。",
  "advice.option_sample_dominant.title": "目前樣本主要是期權",
  "advice.option_sample_dominant.body": "期權 PF {optionProfitFactor}、勝率 {optionWinRate}。請把到期、行權、最後交易時段與 IV 變化分開復盤，不要只看總盈虧。",
  "advice.stock_sample_dominant.title": "目前樣本主要是股票",
  "advice.stock_sample_dominant.body": "股票 PF {stockProfitFactor}、勝率 {stockWinRate}。下一步應檢查持倉時間、止損一致性與是否追高，而不是直接把股票結果和期權混在一起看。",
  "advice.weak_option_underlying_days.title": "期權弱勢標的日期要單獨復盤",
  "advice.weak_option_underlying_days.body": "{rows}。這些組合比總表更接近實際決策場景，應優先檢查當天方向、入場時間與是否接近到期。",
  "advice.clean_sample.title": "先保持樣本乾淨",
  "advice.clean_sample.body": "目前沒有明顯單一資產類別拖累。下一步可以累積更多樣本，再看週期性、標的集中度與策略穩定性。",
} satisfies Translations;
